import camelCase from 'lodash.camelcase';
import * as React from 'react';
import { memo } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { routes } from 'defs';

import i18n from 'helper/i18n';
import { compileDynamicRoute } from 'helper/string';

import Cta from 'components/atoms/Cta';
import Flag from 'components/atoms/Flag';
import { ImageProps } from 'components/atoms/Image';
import Image from 'components/atoms/Image';
import Info from 'components/atoms/Info';
import Intensity from 'components/atoms/Intensity';
import Triangle from 'components/atoms/Triangle';

export type ProgramTeaserProps = {
	modifier?: string;
	intensity?: number;
	duration: number;
	count?: number;
	hasCta?: boolean;
	flag?: any;
	hasInfo?: boolean;
	isNewProgram?: boolean;
	title: string;
	seoTitle?: string;
	goal: string;
	slug: string;
	externalId: string;
	previewImage?: ImageProps;
};

class ProgramTeaser extends React.Component<ProgramTeaserProps> {
	public static displayName = 'ProgramTeaser';

	public static defaultProps = {
		slug: '',
		externalId: '',
		hasCta: true,
		hasInfo: true,
		isNewProgram: false,
		goal: '',
	};

	get previewUrl(): string {
		const { slug, externalId } = this.props;
		const routeTemplate = routes.program.preview.href;
		const programIdentifier = slug || externalId;

		return compileDynamicRoute(routeTemplate, {
			id: programIdentifier,
		});
	}

	public render() {
		const { previewImage, title, intensity, duration, modifier, hasCta, hasInfo, goal, isNewProgram } = this.props;

		return (
			<div className={`m-program-teaser${modifier ? ` m-program-teaser--${modifier}` : ''}`}>
				<RouterLink className="m-program-teaser__link" to={this.previewUrl}>
					<div className="m-program-teaser__content">
						<div className="m-program-teaser__image">
							<Image {...previewImage!} />
						</div>
						<div className="m-program-teaser__text">
							<div className="m-program-teaser__flag">
								<Flag
									text={i18n(`react.impulsCoach.components.ProgramTeaser.flag.${camelCase(goal)}`)}
								/>
							</div>
							<div className="m-program-teaser__triangle">
								<Triangle />
							</div>
							<h2 className="m-program-teaser__title">
								{isNewProgram && (
									<div className="m-program-teaser__title-flag">
										<Flag
											modifier="yellow"
											text={i18n(`react.impulsCoach.components.ProgramTeaser.newFlag`)}
										/>
									</div>
								)}
								{isNewProgram && (
									<span className="m-program-teaser__title-tip">
										{i18n(`react.impulsCoach.components.ProgramTeaser.newFlagTitle`)}
									</span>
								)}{' '}
								{title}
							</h2>
							<div className="m-program-teaser__info">
								{hasInfo && (
									<Info
										label={i18n('react.impulsCoach.components.ProgramTeaser.durationCaption')}
										text={`${duration} ${
											duration === 1
												? i18n('react.impulsCoach.components.ProgramTeaser.day')
												: i18n('react.impulsCoach.components.ProgramTeaser.days')
										}`}
									/>
								)}
								{intensity && (
									<Intensity
										value={intensity}
										modifier={modifier === 'small' ? 'program-teaser' : ''}
										label={i18n('react.impulsCoach.components.ProgramTeaser.intensityCaption')}
									/>
								)}
							</div>
						</div>
					</div>
					{hasCta && (
						<div className="m-program-teaser__cta">
							<object type="nested/link">
								<Cta
									icon="arrow-right"
									size="s"
									routeTo={this.previewUrl}
									label={i18n('react.impulsCoach.components.ProgramTeaser.viewCta')}
								/>
							</object>
						</div>
					)}
				</RouterLink>
			</div>
		);
	}
}

export { ProgramTeaser };
export default memo(ProgramTeaser);
